var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 18.667V20a1 1 0 001 1h1.333v-1.5H4.5v-.833H3zM5.333 3H4a1 1 0 00-1 1v1.333h1.5V4.5h.833V3zM3 16h1.5v-2.667H3V16zm0-5.333h1.5V8H3v2.667zM8 3v1.5h2.667V3H8zm5.333 0v1.5H16V3h-2.667zm5.334 0v1.5h.833v.833H21V4a1 1 0 00-1-1h-1.333zM21 8h-1.5v2.667H21V8zm0 5.333h-1.5V16H21v-2.667zm0 5.334h-1.5v.833h-.833V21H20a1 1 0 001-1v-1.333zM16 21v-1.5h-2.667V21H16zm-5.333 0v-1.5H8V21h2.667z",
    fill: "currentColor"
  })));
}
SvgPlaceholder.displayName = 'Placeholder';
export default SvgPlaceholder;